
export const getStyles = (components, { palette = {} } = {}) => ({
  banner: {
    minHeight: 150,
    borderTop: '1px solid #dfdfdf',
    width: 679,
    position: 'absolute',
    bottom: 0,
    '& .creative-decorator': {
      borderRadius: 6,
      marginRight: 8,
      marginBottom: 32,
      '&.selected': {
        outlineColor: palette.themePrimary,
        outlineStyle: 'solid',
      },
      '& .creative-box': {
        overflow: 'hidden',
        width: 60,
        height: 54,
        borderRadius: 6,
      },
      '& img': {
        height: '100%',
        width: '100%',
        padding: 1,
        objectFit: 'cover',
        borderRadius: 6,
      },
    },
    '& .history-title-container': {
      display: 'flex',
      alignItems: 'center',
      marginTop: 16,
      '& .history-icon': {
        width: 16,
        height: 16,
        display: 'flex',
        alignItems: 'center',
        color: palette.neutralPrimary,
      },
      '& .history-title': {
        marginLeft: 4,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
        color: palette.neutralPrimary,
      },
    },
    '& .history-list-container': {
      '& .history-list': {
        marginTop: 16,
        marginBottom: 12,
        display: 'flex',
      },
    },
  },
});
